export const customTheme = {
 accordion: {
   accentColor: "#1b75bb",
   fontColor: "#666666"
 },
 button: {
   baseColor: "#1b75bb",
   hoverBaseColor: "#0d487a",
   primaryFontColor: "#ffffff",
   primaryHoverFontColor: "#ffffff",
   secondaryFontColor: "#1b75bb",
   secondaryHoverFontColor: "#000000",
   textFontColor: "#1b75bb",
   textHoverFontColor: "#ffffff",
 },
 checkbox: {
   baseColor: "#1b75bb", // checkbox base color theme input
   checkColor: "#ffffff", // checkbox check color theme input
 },
 chip: {
   baseColor: "#eeeeee",
   accentColor: "",
   fontColor: "#000000"
 },
 date: {
   baseColor: "#000000",
   accentColor: "#00adee"
 },
 dropdown: {
   baseColor: "#ffffff",
   fontColor: "#000000"
 },
 footer: {
   baseColor: "#1b75bb",
   fontColor: "#ffffff",
   accentColor: "#f5f2f2",
   logo: "https://assure-new-business-workbench.dev-835.hub-1.sandbox.assure.dxc.com/api/uxconfig/image/image_1616674523795.png"
 },
 header: {
   baseColor: "#ffffff",
   accentColor: "#1b75bb",
   fontColor: "#000000",
   menuBaseColor: "#ffffff",
   hamburguerColor: "#000000",
   logo: "https://assure-new-business-workbench.dev-835.hub-1.sandbox.assure.dxc.com/api/uxconfig/image/image_1616674543928.png",
   logoResponsive: "https://assure-new-business-workbench.dev-835.hub-1.sandbox.assure.dxc.com/api/uxconfig/image/image_1616674551266.png"
 },
 inputText: {
   selectedBaseColor: "#D9D9D9", // inputText selected base color theme input
 },
 paginator: {
   baseColor: "#eeeeee", // paginator base color theme input
   fontColor: "#000000", // paginator font color theme input
 },
 progressBar: {
   accentColor: "#1b75bb", // progressBar accent color theme input
   baseColor: "#000000", // progressBar base color theme input
 },
 radio: {
   baseColor: "#1b75bb", // radio base color theme input
 },
 select: {
   baseColor: "#D9D9D9", // select base color theme input
 },
 sidenav: {
   baseColor: "#F8F8F8",
   arrowBaseColor: "#d9d9d9",
   arrowAccentColor: "#000000"
 },
 slider: {
   baseColor: "#1675bb", // slider base color theme input
 },
 spinner: {
   accentColor: "#0067b3",
   baseColor: "#ffffff"
 },
 switch: {
   checkedBaseColor: "#000000", // switch checked base color theme input
 },
 table: {
   baseColor: "#1b75bb",
   fontColor: "#ffffff"
 },
 tabs: {
   baseColor: "#1b75bb" // tabs base color theme input
 },
 toggleGroup: {
   selectedBaseColor: "#1b75bb",
   selectedHoverBaseColor: "#0d487a",
           selectedFontColor: "#ffffff",
           selectedHoverFontColor: "#ffffff",
           unselectedBaseColor: "#D9D9D9",
           unselectedHoverBaseColor: "#eeeeee",
           unselectedFontColor: "#000000",
           unselectedHoverFontColor: "#000000"
 },
 wizard: {
   baseColor: "#7ed321",
   fontColor: "#000000"
 },
};